import * as angular from 'angular';

import { ComponentDefinition } from '../../models';

class MonthPickerController implements angular.IComponentController {
    interval: {
        interval: number;
        unit: string;
    };

    constructor() {
        this.interval = {
            interval: 1,
            unit: 'M'
        };
    }
}

export const wtMonthPicker: ComponentDefinition = {
    componentId: 'wtMonthPicker',
    controller: MonthPickerController,
    controllerAs: 'vm',
    template: require('./monthPicker.component.html'),
    bindings: {
        disabled: '=?',
        format: '<?',
        initialDate: '<?',
        preventFuture: '<'
    }
};
